import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/softs/batchrename/iconBannerFeature-2.png")